import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import LearningModuleStepView from '../components/LearningModuleStepView';

import {
  loadModuleLearningStep,
  patchModuleLearningStep,
} from '../../../../../state/modules/learnings/actions';

const mapStateToProps = (state, ownProps) => {
  const activeId = state.careGuides.get('activeId');
  const moduleId = ownProps.match.params.moduleId ?? null;
  const moduleStepId = ownProps.match.params.moduleStepId ?? null;

  const learningModuleLearningStep = moduleStepId
    ? denormalize(
        state.entities.getIn(['learningModuleLearningSteps', moduleStepId]),
        schema.learningModuleLearningStep,
        state.entities.toJS()
      )
    : null;

  return { activeId, moduleId, moduleStepId, learningModuleLearningStep };
};

const mapDispatchToProps = (dispatch) => {
  return {
    patch: (careGuideId, id, data, cb) => {
      dispatch(patchModuleLearningStep(careGuideId, id, data, cb));
    },
    load: (careGuideId, id, cb) => {
      dispatch(loadModuleLearningStep(careGuideId, id, cb));
    },
  };
};

const LearningModuleStepViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleStepView);

export default LearningModuleStepViewContainer;
